import { useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { unstable_useBlocker, useBeforeUnload } from 'react-router-dom';
import { resetStateDetectorState } from '../../redux/features/stateDetectorSlice';

const usePrompt = (message, { beforeUnload } = {}) => {
  const reduxDispatch = useDispatch();

  let blocker = unstable_useBlocker(
    useCallback(() => {
      if (typeof message === 'string') {
        const confirm = window.confirm(message);
        if (confirm) {
          reduxDispatch(resetStateDetectorState());
        }
        return !confirm;
      }
      return false;
    }, [message, reduxDispatch])
  );

  let prevState = useRef(blocker.state);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
    prevState.current = blocker.state;
  }, [blocker]);

  useBeforeUnload(
    useCallback(
      event => {
        if (beforeUnload && typeof message === 'string') {
          event.preventDefault();
          event.returnValue = message;
        }
      },
      [message, beforeUnload]
    ),
    { capture: true }
  );
};

const Prompt = ({ when, message, ...props }) => {
  usePrompt(when ? message : false, props);
  return null;
};

export default Prompt;
